export default "__VITE_ASSET__WjGL6r2Q__"